import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/api.service';
import { DialogData } from 'src/app/dynamic-forms/dynamic-form-dialog.component';
import { PatchUserRequest } from 'src/app/models/user';

@Component({
  selector: 'app-terms-condtions',
  templateUrl: './terms-condtions.component.html',
  styleUrls: ['./terms-condtions.component.css'],
})
export class TermsCondtionsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TermsCondtionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private api: ApiService
  ) {}
  form: FormGroup = new FormGroup({
    business: new FormControl(false, [Validators.requiredTrue]),
    service: new FormControl(false, [Validators.requiredTrue]),
  });
  loading: boolean = false;

  ngOnInit(): void {}

  accept() {
    this.loading = true;
    let obj: PatchUserRequest = {
      accepted_terms_at: new Date(
        new Date().toString().split('GMT')[0] + ' UTC'
      )
        .toISOString()
        .split('.')[0],
    };
    this.api.patchUser(obj).subscribe((val) => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
